import { render, staticRenderFns } from "./auction-delivery.vue?vue&type=template&id=18d9702c&"
import script from "./auction-delivery.vue?vue&type=script&lang=js&"
export * from "./auction-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports